import api from "./Api";

class MotoristaEnderecoService {
  GetMotoristaEndereco(payload) {
    return api.get("/v1/motoristaEndereco/" + payload).then((response) => {
      return response.data;
    });
  }

  PostMotoristaEndereco(payload) {
    return api.post("/v1/motoristaEndereco/", payload).then((response) => {
      return response.data;
    });
  }

  PutMotoristaEndereco(payload) {
    return api.put("/v1/motoristaEndereco/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteMotoristaEndereco(payload) {
    return api.delete("/v1/motoristaEndereco/" + payload).then((response) => {
      return response.data;
    });
  }

  GetMotoristaEnderecoOData(payload) {
    return api.get("/OData/MotoristaEndereco" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new MotoristaEnderecoService();
